import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=ec66e656&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=ec66e656&prod&scoped=true&lang=css"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&id=ec66e656&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec66e656",
  null
  
)

export default component.exports